import React from 'react';
import { Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-emerald-900 text-white py-16 px-6" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-serif font-medium mb-4" data-testid="footer-logo">
              Kerala Wedding Experience
            </h3>
            <p className="text-stone-300 leading-relaxed">
              Attend a wedding without responsibilities. Experience authentic Kerala traditions, food, and culture.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-4">Contact</h4>
            <div className="space-y-3 text-stone-300">
              <div className="flex items-center gap-3" data-testid="footer-email">
                <Mail className="w-5 h-5" />
                <a href="mailto:events@thaalikettu.com" className="hover:text-yellow-400 transition-colors">
                  events@thaalikettu.com
                </a>
              </div>
              <div className="flex items-center gap-3" data-testid="footer-phone">
                <Phone className="w-5 h-5" />
                <a href="tel:+919074500956" className="hover:text-yellow-400 transition-colors">
                  Call Us
                </a>
              </div>
              <div className="flex items-center gap-3" data-testid="footer-location">
                <MapPin className="w-5 h-5" />
                <span>Kochi, Kerala, India</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
              <a 
                href="https://wa.me/919074500956" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-8 text-center text-stone-300" data-testid="footer-copyright">
          <p>© 2026 Kerala Wedding Experience. Designed & curated in Kerala 🌴</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;